import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  variant?: 'default' | 'urgent';
}
export function CountdownTimer({
  variant = 'default'
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(600); // 10 minutes
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');
  if (variant === 'urgent') {
    return <div className="bg-red-600 text-white rounded-2xl p-6 md:p-8 shadow-[0_10px_40px_rgba(220,38,38,0.5)] border-2 border-red-700" data-id="element-257">
        <h3 className="text-2xl md:text-3xl font-serif font-bold text-center mb-2 uppercase tracking-wide" data-id="element-258">
          ¡Oferta solo por hoy!
        </h3>
        <p className="text-center text-white/90 text-sm md:text-base mb-1" data-id="element-259">
          Tu lugar solo está reservado por <strong data-id="element-260">10 minutos</strong>.
        </p>
        <p className="text-center text-white/80 text-xs md:text-sm mb-5" data-id="element-261">
          En caso de no acceder, se cederá a otra persona.
        </p>
        <p className="text-center text-white/90 text-sm uppercase tracking-widest mb-3" data-id="element-262">
          La oferta se termina en:
        </p>
        <div className="flex justify-center items-center space-x-3 md:space-x-4" data-id="element-263">
          <div className="bg-white text-red-600 rounded-xl px-5 md:px-7 py-3 md:py-4 shadow-lg" data-id="element-264">
            <div className="text-5xl md:text-6xl font-bold font-sans tabular-nums leading-none" data-id="element-265">
              {minutes}
            </div>
          </div>
          <div className="text-5xl md:text-6xl font-bold text-white animate-pulse" data-id="element-266">
            :
          </div>
          <div className="bg-white text-red-600 rounded-xl px-5 md:px-7 py-3 md:py-4 shadow-lg" data-id="element-267">
            <div className="text-5xl md:text-6xl font-bold font-sans tabular-nums leading-none" data-id="element-268">
              {seconds}
            </div>
          </div>
        </div>
        <div className="flex justify-center space-x-12 md:space-x-16 mt-2" data-id="element-269">
          <span className="text-xs uppercase tracking-widest text-white/80" data-id="element-270">
            Minutos
          </span>
          <span className="text-xs uppercase tracking-widest text-white/80" data-id="element-271">
            Segundos
          </span>
        </div>
        <div className="mt-6 text-center" data-id="element-272">
          <span className="inline-block bg-white text-red-600 font-bold text-base md:text-lg px-6 py-2 rounded-full border-2 border-gold" data-id="element-273">
            ¡AHORRÁ EL 70%!
          </span>
        </div>
      </div>;
  }
  return <div className="flex flex-col items-center justify-center space-y-2" data-id="element-274">
      <div className="flex space-x-2 text-4xl md:text-5xl font-bold text-dark" data-id="element-275">
        <div className="bg-cream px-4 py-2 rounded-lg border border-burgundy/20 shadow-sm tabular-nums" data-id="element-276">
          {minutes}
        </div>
        <span className="text-burgundy self-center animate-pulse" data-id="element-277">:</span>
        <div className="bg-cream px-4 py-2 rounded-lg border border-burgundy/20 shadow-sm tabular-nums" data-id="element-278">
          {seconds}
        </div>
      </div>
    </div>;
}